// Announcement ticker: clones the message group (hidden from assistive tech) so the
// CSS animation can loop seamlessly. Reduced-motion users get the static list.
class STicker extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const track = this.querySelector("[data-ticker-track]");
    const group = this.querySelector("[data-ticker-group]");
    if (!track || !group || track.querySelector("[data-ticker-clone]")) return;
    const clone = group.cloneNode(true);
    clone.removeAttribute("data-ticker-group");
    clone.setAttribute("data-ticker-clone", "");
    clone.setAttribute("aria-hidden", "true");
    clone.inert = true;
    track.append(clone);
    track.classList.add("animate-ticker");
  }
}

if (!customElements.get("s-ticker")) customElements.define("s-ticker", STicker);
